export default function toLocaleString(v) {
  return v.toLocaleString()
}
